import React, { useState, useEffect } from 'react';
import API, { UPLOADS_URL } from '../api/axios';

const AnnouncementPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [popupData, setPopupData] = useState({ enabled: false, image: null });

  useEffect(() => {
    // Fetch settings to check if popup is enabled
    API.get('/settings/public')
      .then(res => {
        if (res.data?.data) {
          const data = res.data.data;
          if (data.popup_enabled) {
            setPopupData({
              enabled: true,
              image: data.popup_image ? `${UPLOADS_URL}/${data.popup_image}` : `${process.env.PUBLIC_URL}/images/asmission-open.jpg`
            });
            // Show popup if enabled
            const timer = setTimeout(() => {
              setIsOpen(true);
            }, 1000);
            return () => clearTimeout(timer);
          }
        }
      })
      .catch(err => console.error("Error fetching settings for popup", err));
  }, []);

  const closePopup = () => {
    setIsOpen(false);
  };

  // Only render if it's open, enabled, and we have an image
  if (!isOpen || !popupData.enabled || !popupData.image) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm transition-opacity">
      <div 
        className="relative max-w-lg w-full bg-white rounded-2xl shadow-2xl overflow-hidden animate-fade-down"
      >
        <button 
          onClick={closePopup}
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-black/50 hover:bg-primary text-white rounded-full transition-colors z-10"
          aria-label="Close Announcement"
        >
          <i className="fas fa-times"></i>
        </button>
        
        <img 
          src={popupData.image} 
          alt="Announcement" 
          className="w-full h-auto block"
        />
      </div>
    </div>
  );
};

export default AnnouncementPopup;
